module.exports = __webpack_public_path__ + "static/media/pandianliucheng61.287d0de1.png";